import { useNavigate } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { useDispatch, useSelector } from 'react-redux';
import { setAccountOpening, setApplicationId } from '../../store/slices/contentSlice';
import { getContentKeyAccToLang, setToken } from '../../utils/utils';
import { logoutAction } from '../../store/actions/authActions';

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { TextWeight, isArabic } = dynamicfunction();
  const user = useSelector((state) => state.content?.user);
  const corpAOContent = useSelector((state) => state.content?.corpAOContent);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(corpAOContent?.corporate_progress_saved?.data?.attributes, key, isArabic)
  }
  // same logout as the CorporateForm header logout
  const handleLogout = () => {
    const redirect_url = `${process.env.REACT_APP_OPEN_ACCOUNT_LINK}${isArabic ? 'ar' : 'en'}`;
    dispatch(setAccountOpening(null))
    dispatch(setApplicationId(null))
    setToken("")
    dispatch(logoutAction());
    window.location.href = redirect_url;
  };

  return { TextWeight, navigate, handleLogout, getContentKey };
};
